import translator from '@Components/Utilities/Translator';
import { useRecoilValue } from 'recoil';
import atoms from '@Components/Utilities/SandhillsAtoms';
import '@Styles/components/_listing-input-plug.scss';

const ListingInputPlug = () => {
    const currentSite = useRecoilValue(atoms.currentWebsite);
    const brand = currentSite?.ProperDisplayDomainName || '';

    return (
        <div className="listing-input-plug">
            <a 
                rel='nofollow' 
                className="sell-container" 
                href={`/listinginput/?utm_source=${brand}&utm_medium=list-static-banner&utm_campaign=sellpromo`}
                target="_blank" 
                aria-label={"Ready to Sell? List Today! (" + translator.translate('sandhills.opensinanewtab') + ")"}
            >
                <div className="sell-text">
                    <div>Ready to Sell? <strong>List Today!</strong></div>  
                </div>
            </a>
        </div>
    );
}

export default ListingInputPlug;
